import type { HTMLAttributes } from 'react';
import { cn } from '@/utils/cn';

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        // White card on the off-white sheet, outlined in the brand's Gray.
        // `shadow-card` supplies both the hairline ring and a soft drop, so
        // there is no `border-*` here — the edge is what separates a white
        // card from a near-white ground, and a border plus a ring would read
        // as a double line.
        'glass-surface rounded-lg p-5 shadow-card',
        className,
      )}
      {...props}
    />
  );
}
